import { useIsDesktop } from '@kanda-libs/ks-design-library';
import type {
  FinanceStatus,
  Job,
  JobCreditState,
} from '@kanda-libs/ks-frontend-services';
import { useJobContext } from 'pages/Job/context';
import { useMemo } from 'react';
import { checkJobPaidByOB } from 'utils/Job-functions';

export interface JobStatusBarHook {
  price: number;
  status: Job['status'];
  financeStatus: FinanceStatus | undefined;
  checkJobStatus: JobCreditState['current_status'] | undefined;
  paidByBank: boolean;
  example: boolean;
  archive: boolean;
  isLoading: boolean;
  isDesktop: boolean;
  changesRequested: boolean;
}

export default function useJobStatusBar(): JobStatusBarHook {
  const { job, checkJob, example, archived, changesRequested, isLoading } =
    useJobContext();
  const isDesktop = useIsDesktop();

  const price = useMemo(
    () => job?.total?.amount_vat_inclusive?.amount || 0,
    [job],
  );

  const status = useMemo(() => job?.status, [job]);

  const paidByBank = useMemo(() => checkJobPaidByOB(job), [job]);

  const financeStatus = useMemo(() => job?.finance_status, [job]);

  const checkJobStatus = useMemo(() => checkJob?.current_status, [checkJob]);

  return {
    price,
    status,
    financeStatus,
    checkJobStatus,
    paidByBank,
    example,
    archive: archived,
    isLoading,
    isDesktop,
    changesRequested,
  };
}
